import { Component, Input } from "@angular/core";
import { Assignment } from "@apaq/orgkit-js";
import { addMinutes, subMinutes } from "date-fns";

@Component({
  selector: 'app-time-label',
  template: `
    <sl-label size="small">{{startTime | date:'short'}} - {{endTime | date:'shortTime'}}</sl-label>
  `,
  styles: [
    ':host {display:inline-block}'
  ]
})
export class TimeLabelComponent {
  @Input() assignment?: Assignment;

  get startTime() {
    if (this.assignment?.plan != null) {
      if (this.assignment?.action === 'Completed' && this.assignment.handledDate != null) {
        return subMinutes(this.assignment.handledDate, this.getDuration());
      } else {
        return this.assignment.plan.executionTime;
      }
    } else {
      return new Date();
    }
  }

  get endTime() {
    if (this.assignment?.plan != null) {
      if (this.assignment?.action === 'Completed' && this.assignment.handledDate != null) {
        return this.assignment.handledDate;
      } else {
        return addMinutes(this.assignment.plan.executionTime, this.getDuration());
      }
    } else {
      return new Date();
    }
  }

  private getDuration() {
    let duration = 0;
    this.assignment?.tasks.forEach(t => duration += t.duration);
    return duration;
  }
}